module.exports = {"TXTCLI_Tournament_Information":{"id":"TXTCLI_Tournament_Information","defaultMessage":"Infos sur le tournoi"}}